// Build and download a .eml file that Outlook opens in editable compose mode.
// The X-Unsent: 1 header is the trick — without it Outlook opens the .eml as a
// read-only received-message inspector. Date and Message-ID must be omitted —
// their presence makes Outlook treat the file as already sent. From is fine to
// include and helps Outlook pick the right mailbox when the user has multiple
// accounts configured.

const FROM_ADDRESS = "accounts@axisagency.co.uk";

export const arrayBufferToBase64Pdf = (arrayBuffer) => {
  const uint8 = new Uint8Array(arrayBuffer);
  let binary = "";
  for (let i = 0; i < uint8.length; i++) binary += String.fromCharCode(uint8[i]);
  return btoa(binary);
};

export const downloadInvoiceEml = ({ to, subject, body, attachments, filename }) => {
  const boundary = `----=_AxisInvoice_${Date.now()}`;

  const attachmentParts = (attachments || []).map((att) => [
    `--${boundary}`,
    `Content-Type: application/pdf; name="${att.filename}"`,
    `Content-Disposition: attachment; filename="${att.filename}"`,
    `Content-Transfer-Encoding: base64`,
    ``,
    att.base64,
    ``,
  ].join("\r\n"));

  const eml = [
    `X-Unsent: 1`,
    `From: ${FROM_ADDRESS}`,
    `To: ${to || ""}`,
    `Subject: ${subject || ""}`,
    `MIME-Version: 1.0`,
    `Content-Type: multipart/mixed; boundary="${boundary}"`,
    ``,
    `--${boundary}`,
    `Content-Type: text/plain; charset=UTF-8`,
    ``,
    body || "",
    ``,
    ...attachmentParts,
    `--${boundary}--`,
  ].join("\r\n");

  const blob = new Blob([eml], { type: "message/rfc822" });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  window.URL.revokeObjectURL(url);
};
